export default __webpack_public_path__ + "static/media/spacelist_logo.c6e3d303.svg";